export default (data) => {

  const totalNewFrontGP = data.total_new_front_GP ? parseInt(data.total_new_front_GP) : 0;
  const totalNewBackGP = data.total_new_back_GP ? parseInt(data.total_new_back_GP) : 0;
  const totalUsedFrontGP = data.total_used_front_GP ? parseInt(data.total_used_front_GP) : 0;
  const totalUsedBackGP = data.total_used_back_GP ? parseInt(data.total_used_back_GP) : 0;
  const totalServiceGP = data.total_service_GP ? parseInt(data.total_service_GP) : 0;
  const totalApparelGross=data.total_apparel_gross? parseInt(data.total_apparel_gross) : 0;
  const totalBoatsFrontGP = data.total_boats_front_GP ? parseInt(data.total_boats_front_GP) : 0;
  const totalBoatsBackGP = data.total_boats_back_GP ? parseInt(data.total_boats_back_GP) : 0;
    const totalBikesFrontGP = data.total_bikes_front_GP ? parseInt(data.total_bikes_front_GP) : 0;
const totalBikesBackGP = data.total_bikes_back_GP ? parseInt(data.total_bikes_back_GP) : 0;
  const totalTrailersFrontGP = data.total_trailers_front_GP ? parseInt(data.total_trailers_front_GP) : 0;
  const totalTrailersBackGP = data.total_trailers_back_GP ? parseInt(data.total_trailers_back_GP) : 0;
  const totalWholesaleVehicleGP = data.total_wholesale_total_GP ? parseInt(data.total_wholesale_total_GP) : 0;
  const totalWholeSaleGP = data.total_parts_whole_sale_GP ? parseInt(data.total_parts_whole_sale_GP) : 0;


  // const totalPartsGP = data.total_parts_retail_GP ? parseInt(data.total_parts_retail_GP) : 0;
  const totalPartsRetailGP = data.total_parts_retail_GP ? parseInt(data.total_parts_retail_GP) : 0;
  const totalBodyshopGP = data.total_bodyshop_total_GP ? parseInt(data.total_bodyshop_total_GP) :
    (data.total_bodyshop_GP ? parseInt(data.total_bodyshop_GP) :
      (data.total_bodyshop ? parseInt(data.total_bodyshop) : 0));
  const total = totalBikesFrontGP + totalBikesBackGP + totalNewFrontGP + totalNewBackGP + totalUsedFrontGP + totalUsedBackGP + totalWholesaleVehicleGP + totalServiceGP + totalPartsRetailGP + totalApparelGross + totalBoatsFrontGP + totalBoatsBackGP + totalTrailersFrontGP + totalTrailersBackGP + totalWholeSaleGP + totalBodyshopGP;

  if(total === 'NaN' || total === 'Infinity') {
    return '0'
  } else {
    return parseFloat(total?.toFixed());
  }
};